import { Component, Input ,PLATFORM_ID ,Inject,ElementRef, ViewChild} from '@angular/core';
import { CommonModule,isPlatformBrowser  } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatProgressBarModule} from '@angular/material/progress-bar';

import { BaseChartDirective } from 'ng2-charts'; 
import { ChartConfiguration, ChartData} from 'chart.js';

import { AnalysisOptionsComponent } from '../../../tools/analysis-options/analysis-options.component';

import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FacadeService } from '../../../services/facade.service';
import { ProyectosService } from '../../../services/proyectos.service';

//Variables del Navegador
type MenuItem = 'summary' | 'charts' ;

//Variable para expandir cada cuadro
interface ExpandedState {
  [key: string]: boolean;
}

interface WordCount {
  word: string;
  count: number;
}

interface Data {
  [key: string]: WordCount[];
}

interface DividedData {
  [key: string]: WordCount[][];
}

@Component({
  selector: 'awl',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    AnalysisOptionsComponent,
    BaseChartDirective,
    HttpClientModule],
  templateUrl: './awl.component.html',
  styleUrl: './awl.component.css'
})
export class AwlComponent {
  selectedMenuItem: MenuItem = 'summary';
  @Input() checked: boolean; //Variable del mat-slide-toggle del text-component
  isScreenLarge: boolean = false;

  isIconRotated = false;

  loaderActive: boolean;
  loaderActive2: boolean;
  loaderActiveFirstProject: boolean;

  short_words:boolean;

  UpdateAWL:boolean = false;

  activeEyeIcon: HTMLImageElement | null = null;

  public data_pof = {};
  public data_pof3 = {};

  imgSrc: { [key: string]: string } = {};

  project_data: any;
  palabraresaltada = {};
  public ishighlighted = {};

  //Valores para expandir cada Cuadro
  public isExpanded: ExpandedState = {};
  public encabezados={};
  public colores_dinamicos={};

  verifyLoaderActive2: boolean;

  public awl = {
    too_short_error:false
  }

  respuestaWords: any[] = [
    { "value": "AWL1", "descripcion": "AWL 1" },
    { "value": "AWL2", "descripcion": "AWL 2" },
    { "value": "AWL3", "descripcion": "AWL 3" },
    { "value": "AWL4", "descripcion": "AWL 4" },
    { "value": "AWL5", "descripcion": "AWL 5" },
    { "value": "AWL6", "descripcion": "AWL 6" },
    { "value": "AWL7", "descripcion": "AWL 7" },
    { "value": "AWL8", "descripcion": "AWL 8" },
    { "value": "AWL9", "descripcion": "AWL 9" },
    { "value": "AWL10", "descripcion": "AWL 10" },
    { "value": "AWL11", "descripcion": "AWL 11" },
    { "value": "AWL12", "descripcion": "AWL 12" },
    { "value": "AWL13", "descripcion": "AWL 13" },
    { "value": "AWL14", "descripcion": "AWL 14" },
    { "value": "AWL15", "descripcion": "AWL 15" },
    { "value": "K1", "descripcion": "K1" },
    { "value": "K2", "descripcion": "K2" },
    { "value": "K3", "descripcion": "K3" },
    { "value": "K4", "descripcion": "K4" },
    { "value": "K5", "descripcion": "K5" },
  ];
  cambios_de_palabras = []

  public hideEyeIconsForSafari1561 = false;

  ngOnInit(): void {
    localStorage.setItem("actual","awl")
    this.isButtonDisabled();
    this.hideEyeIconsForSafari1561 = false;
    if (isPlatformBrowser(this.platformId)) {
      this.isScreenLarge = window.innerWidth > 1000;
      window.addEventListener('resize', this.onResize.bind(this));
    }
    this.initSubscribe();
     if(sessionStorage.getItem("id_project")){
    this.initAwl();
     }
    if(sessionStorage.getItem("text_UID")){
      this.loaderActive = true;
    }
    this.proyectoService.loader$.subscribe(loader => {
      if(this.loaderActive2){
        this.loaderActive = false;
      }else{
        this.loaderActive = loader;
      }
    });

        this.proyectoService.loaderAnalyzing$.subscribe(loader => {
      if(loader){
        this.loaderActive2 = true;
      }
      if(!loader){
        this.loaderActive2 = false;
      }
    });

         this.proyectoService.loaderCreatingProject$.subscribe(value => {
      if(value){
        this.loaderActive2 = true;
      }
      if(!value){
        this.loaderActive2 = false;
      }
    });
    // **Inicializar correctamente el estado de los ojos**
    Object.keys(this.data_pof3).forEach(categoria => {
      this.isEyeOn[categoria] = false; // Todas inician apagadas
    });

    this.categoriasActivas.clear(); // Limpiar selección inicial

  // **Inicializar correctamente el estado de los ojos**
    Object.keys(this.data_pof3).forEach(categoria => {
        this.isEyeOn[categoria] = false; // Todas las categorías inician apagadas
    });

    this.categoriasActivas.clear(); // Limpiar selección inicial


            this.proyectoService.verifyloaderAnalyzing$.subscribe(value => {
      if(value){
        this.verifyLoaderActive2 = true;
      }
      if(!value){
        this.verifyLoaderActive2 = false;
      }
    });

  }

  encontrarCantidad(palabra, categoria){
    categoria = categoria.toUpperCase()
    return this.data_pof[categoria][palabra];
  }

  public isSafariVersion1561(): boolean {
    const ua = navigator.userAgent;
    const safariMatch = ua.match(/Version\/([\d.]+) Safari\//);
    const isSafari = ua.includes("Safari") && ua.includes("Macintosh") && !ua.includes("Chrome");

    if (safariMatch && safariMatch[1] && isSafari) {
      return safariMatch[1] === "15.6.1";
    }

    return false;
  }

  async onSelectionRadioChange(palabra, position, origen, categoria, description) {
    let data = {
      "palabra":palabra,
      "origen": origen.toUpperCase(),
      "new_category": categoria.toUpperCase(),
      "position": position,
      "description": description
    }
    let editado = false
    for (let index = 0; index < this.cambios_de_palabras.length; index++) {
      let element = this.cambios_de_palabras[index];
      if (element.position == data.position){
        editado = true
        this.cambios_de_palabras[index] = data;
        break
      }
    }
    if (!editado){
      this.cambios_de_palabras.push(data)
    }
    this.proyectoService.undoMarcadoMultiple(this.http);
    // console.log(data);
  }

  isWordSelected(valor, categoria, item){
    return (valor == categoria.toUpperCase())
  }

  public data: Data = {};

  //Dividir los datos obtenidos entre las 3 columnas al expandir la informacion

  public dividedData: DividedData = {};

  onResize() {
    this.isScreenLarge = window.innerWidth > 1000;
  }

  divideData() {
    for (const key in this.data_pof) {
      if (this.data_pof.hasOwnProperty(key)) {
        const items = this.data_pof[key];
        const chunkSize = Math.ceil(items.length / 3);
        this.dividedData[key] = [
          items.slice(0, chunkSize),
          items.slice(chunkSize, chunkSize * 2),
          items.slice(chunkSize * 2),
        ];
      }
    }
  }

  toggleIcon() {
    this.isIconRotated = !this.isIconRotated;
  }

  resetIcon() { this.isIconRotated = false; }

  //Funcion para expandir cada cuadro
  toggleExpand(identifier: string) {
    this.isExpanded[identifier] = !this.isExpanded[identifier];
  }

  toggleExpandAll() {
    // Verificar si todos los valores son true
    const allExpanded = Object.values(this.isExpanded).every(value => value);
  

    // Crear una copia de las claves originales
    const keys = Object.keys(this.isExpanded);

    // Iterar sobre las claves originales
    keys.forEach(originalKey => {
      let formattedKey = originalKey;

      // Manejar el caso especial de "unlisted"
      if (originalKey.toLowerCase() === "unlisted") {
        formattedKey = "UNLISTED";
      } else {
        // Formatear todas las demás claves a mayúsculas
        formattedKey = originalKey.toUpperCase();

        // Verificar si el identificador coincide con el patrón "AWL X"
        if (/^AWL\s?\d+$/.test(formattedKey)) {
          formattedKey = formattedKey.replace(/^AWL\s?(\d+)$/, "AWL$1");
        }
      }

      // Actualizar el estado del valor en la clave original
      this.isExpanded[originalKey] = !allExpanded;

      // Si la clave formateada es diferente y no existe en el objeto
      if (formattedKey !== originalKey && this.isExpanded[formattedKey] === undefined) {
        // Reflejar el cambio en el formato deseado
        this.isExpanded[formattedKey] = this.isExpanded[originalKey];
        delete this.isExpanded[originalKey]; // Eliminar la clave original si se renombra
      }

    
    });

    // Actualizar showAll después de realizar los cambios
    this.showAll = allExpanded;

  }


  showAll: boolean = true;
  private proyectoSub;

  constructor(
    private http: HttpClient,
    public fachada: FacadeService,
    public proyectoService: ProyectosService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.checked = true; 
    // this.divideData();
  }

  ngOnDestroy(): void {
    this.proyectoSub?.unsubscribe();
  }

  initSubscribe() {
    if (!this.proyectoSub || this.proyectoSub.closed) {
      //Subscribimos al servicio para escuchar los datos
      this.proyectoSub = this.proyectoService.proyecto$.subscribe(({ proyecto, firstProject })=>{
         if(!firstProject){
            this.loaderActive = false;
            if(sessionStorage.getItem("text_UID")){
              if(!this.loaderActiveFirstProject){
              this.loaderActive2 = true;
            }
            }else{
              this.loaderActive2 = false;
            }
          }
          if(firstProject){
            this.loaderActive = false;
            if(sessionStorage.getItem("text_UID")){
              this.loaderActiveFirstProject = true;
            }else{
              this.loaderActiveFirstProject = false;
            }
          }
        console.log("Update de data --Reporta: AWL--")
        this.project_data = proyecto;
  
         // Apagar todas las palabras resaltadas
        Object.keys(this.palabraresaltada).forEach(categoria => {
          Object.keys(this.palabraresaltada[categoria]).forEach(palabra => {
              this.palabraresaltada[categoria][palabra] = false;
          });
        });
  
        // Apagar todos los ojos de verPalabra
        Object.keys(this.palabraSeleccionada).forEach(key => {
          this.palabraSeleccionada[key] = false;
        });
  
         // **Apagar todas las palabras resaltadas activadas por toggleEyeIconPalabra**
        Object.keys(this.palabraresaltada).forEach(categoria => {
          Object.keys(this.palabraresaltada[categoria]).forEach(palabraResaltada => {
            this.palabraresaltada[categoria][palabraResaltada] = false;
          });
        });
  
        // Apagar ojos
        Object.keys(this.isEyeOn).forEach(categoria => {
          this.isEyeOn[categoria] = false;
        });
  
        this.categoriasActivas.clear();
        this.seeAllActive = false;
        this.seeAllIconSrc = '../../assets/images/eye-icon.svg';
  
        this.proyectoService.undoMarcadoMultiple(this.http);
        if(sessionStorage.getItem("id_project")){

        this.initAwl();
        }
      });
    }
  }

  status: any;
  async initAwl(){
     let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "awl"){
      // Intentar recuperar el resumen desde sessionStorage
      const memoryStorage = sessionStorage.getItem("awl");
  
      if (memoryStorage && !this.UpdateAWL) {
        if(memoryStorage !== "-"){
        try {
        // Si existe, convertirlo de JSON string a objeto y asignarlo
        let respuesta = JSON.parse(memoryStorage);
        this.encabezados = respuesta.encabezados
        this.short_words = this.awl.too_short_error;
        this.data_pof = {}
        for (const item of Object.keys(this.encabezados)) {
          this.isExpanded[item] = this.isExpanded[item] ?? false
          if(item == "unlisted" || item == "awlTotal"){
            this.colores_dinamicos[item] = 'transparent'
          }else{
            this.colores_dinamicos[item]=this.traducirColor(item)
          }
          // console.log(this.getRandomHexColor())
        }
  
        for (const key in respuesta.taggeddata) {
          this.data_pof[key] = {};
          this.data_pof3[key] = {};
          for (const palabra in respuesta.taggeddata[key]) {
              this.data_pof[key][palabra] = respuesta.taggeddata[key][palabra].count;
              this.data_pof3[key][palabra] = respuesta.taggeddata[key][palabra].position;
          }
        }
        //TODO: Rehacer el objeto de datos que se van a mostrar dentro de cada row de AWL
        this.changecharData()
  
        for (const key in this.encabezados) {
          this.isExpanded[key] = this.isExpanded[key] ?? false;
          this.ishighlighted[key] = this.ishighlighted[key] ?? false;
          const previousWordHighlights = this.palabraresaltada[key] ?? {};
          this.palabraresaltada[key] = {};
          for (const palabra in this.data_pof[key.toUpperCase()]) {
              this.palabraresaltada[key][palabra] = previousWordHighlights[palabra] ?? false;
          }
        }
        } catch (error) {
        console.log("Error en la petición de datos")
        console.log(error)
        } finally {
        this.loaderActive2 = false;
        this.loaderActive = false;
        this.loaderActiveFirstProject = false;
        this.proyectoService.updateloader(false);
        }
      }
      }
      if(!memoryStorage || this.UpdateAWL){
        sessionStorage.setItem("awl", "-");
        try {
          let textUID = sessionStorage.getItem('text_UID');
          let respuesta = await this.fachada.getLexicalAWLOfProject(this.http,textUID,"");
          // Guardar la respuesta en sessionStorage
          sessionStorage.setItem("awl", JSON.stringify(respuesta));
          this.encabezados = respuesta.encabezados
          this.short_words = this.awl.too_short_error;
          this.data_pof = {}
          for (const item of Object.keys(this.encabezados)) {
            this.isExpanded[item] = this.isExpanded[item] ?? false
            if(item == "unlisted" || item == "awlTotal"){
              this.colores_dinamicos[item] = 'transparent'
            }else{
              this.colores_dinamicos[item]=this.traducirColor(item)
            }
            // console.log(this.getRandomHexColor())
          }
  
          for (const key in respuesta.taggeddata) {
            this.data_pof[key] = {};
            this.data_pof3[key] = {};
            for (const palabra in respuesta.taggeddata[key]) {
                this.data_pof[key][palabra] = respuesta.taggeddata[key][palabra].count;
                this.data_pof3[key][palabra] = respuesta.taggeddata[key][palabra].position;
            }
          }
        //TODO: Rehacer el objeto de datos que se van a mostrar dentro de cada row de AWL
        this.changecharData()
  
        for (const key in this.encabezados) {
          this.isExpanded[key] = this.isExpanded[key] ?? false;
          this.ishighlighted[key] = this.ishighlighted[key] ?? false;
          const previousWordHighlights = this.palabraresaltada[key] ?? {};
          this.palabraresaltada[key] = {};
          for (const palabra in this.data_pof[key.toUpperCase()]) {
              this.palabraresaltada[key][palabra] = previousWordHighlights[palabra] ?? false;
          }
        }
        this.status = 200
      } catch (error) {
           if (error?.status === 0) {
            console.error("Error 500: Error interno del servidor (awl)");
            sessionStorage.removeItem('awl');
            this.status = 0

          } else {
            console.log("Otro error en la petición de datos")
            console.log(error)
            sessionStorage.removeItem('awl');
          }
          this.status = error?.status;
      } finally {
        if(this.status === 0){
          this.loaderActive2 = true;
          this.loaderActive = true;
          this.loaderActiveFirstProject = true;
          this.proyectoService.updateloader(true);
          this.UpdateAWL = true;
          setTimeout(() => {
              this.initAwl();
            }, 100);
        }else{
          this.loaderActive2 = false;
          this.loaderActive = false;
          this.loaderActiveFirstProject = false;
          this.proyectoService.updateloader(false);
          this.UpdateAWL = false;
        }
         

         
      }
      }
 }else{
      console.log(`awl no es la pantalla actual así que bloqueamos peticiones`)
    }
    
    this.divideData();

  }

  getObjectKeys(obj: any): string[] {
    return Object.keys(obj);
  }
  
  changecharData(){
    let dataset = {
      data:[],
      label: 'Unique Words',
      backgroundColor: [],
      // Hace las barras más delgadas
      barThickness: 40,
    }

    let maxValue = 0;

    this.barChartData.labels = [];
    for (const item of Object.keys(this.encabezados)) {
      const row = this.encabezados[item];
      const rowName = String(row?.Name || '').trim().toUpperCase();
      const isExcludedRow = item === 'unlisted' || item === 'awlTotal' || rowName === 'UNLISTED' || rowName === 'AWL TOTAL';

      if (!isExcludedRow){
        this.barChartData.labels.push(row.Name)
        dataset.backgroundColor.push(this.colores_dinamicos[item])
        const value = this.parsePercentageValue(row.cumul_unique); 
        dataset.data.push(value);
        if (value > maxValue) { 
          maxValue = value;
          } 
      }
    }
    // console.log(dataset)
    this.barChartData.datasets = [dataset];
    this.updateChartOptions(Math.ceil(maxValue));
  }

  private parsePercentageValue(value: any): number {
    if (typeof value === 'number') {
      return value <= 1 ? value * 100 : value;
    }

    const normalizedValue = String(value ?? '').replace('%', '').trim();
    const numericValue = Number(normalizedValue);

    if (Number.isNaN(numericValue)) {
      return 0;
    }

    return numericValue <= 1 && !String(value ?? '').includes('%') ? numericValue * 100 : numericValue;
  }

  
  updateChartOptions(maxValue: number) {
    const stepSize = Math.ceil(maxValue / 5); // Ajustar el tamaño del paso en función del valor máximo
  
    this.barChartOptions = {
      scales: {
        x: {
          grid: {
            display: false, // Ocultar las líneas verticales
          },
        },
        y: {
          min: 0,
          max: maxValue, // Ajuste según el valor máximo calculado
          ticks: {
            stepSize: stepSize, // Incrementos calculados
            callback: function (value) {
              return value + '%'; // Mostrar el símbolo % en las etiquetas
            }
          },
          border: {
            display: false, // Eliminar el borde del eje Y
          },
          grid: {
            color: '#E0E0E0', // Color de las líneas horizontales
          },
        },
      },
      plugins: {
        legend: {
          display: false, // Ocultar la leyenda
        },
        datalabels: {
              display: false // Desactiva los datalabels solo en este gráfico
            },
      },
    };
  }
  

  getRandomHexColor(): string {
    // Define un umbral para evitar colores muy claros (por ejemplo, evita valores mayores a 0xEEEEEE)
    const maxColorValue = 0xEEEEEE;
    const minColorValue = 0x000000; // Puedes ajustar este valor si no quieres colores muy oscuros

    // Genera un número aleatorio en el rango permitido
    const randomColor = Math.floor(Math.random() * (maxColorValue - minColorValue + 1)) + minColorValue;

    // Convierte el número a una cadena hexadecimal y asegúrate de que tenga siempre 6 dígitos
    return '#' + randomColor.toString(16).padStart(6, '0').toUpperCase();
  }

  selectMenuItem(menuItem: MenuItem) {
    this.selectedMenuItem = menuItem;
  }

  isSelected(menuItem: MenuItem): boolean {
    return this.selectedMenuItem === menuItem;
  }

  //Codigo para la Grafica
  public barChartOptions: ChartConfiguration<'bar'>['options'] = {
    scales: {
      x: {
        grid: {
          display: false,  // Ocultar las líneas verticales
        },
      },
      y: {
        min: 0,
        max: 25,  // Límite máximo del eje Y en 25%
        ticks: {
          stepSize: 5,  // Incrementos de 5% en 5%
          callback: function(value) {
            return value + '%';  // Mostrar el símbolo % en las etiquetas
          }
        },
        border: {
          display: false  // Eliminar el borde del eje Y
        },
        grid: {
          color: '#E0E0E0',  // Color de las líneas horizontales
        },
      },
    },
    plugins: {
      legend: {
        display: false, // Ocultar la leyenda
      },
      datalabels: {
              display: false // Desactiva los datalabels solo en este gráfico
            },
    },
  };
  
  
  public barChartType = 'bar' as const;
  
  public barChartData: ChartData<'bar'> = {
    labels: [],
    datasets: [
      { 
        data: [],
        label: 'Knowledge Rank %',
        backgroundColor: [],
        // Hace las barras más delgadas
        barThickness: 40,
      },
    ],
  };

  ponerOjo(event: MouseEvent, categoria: string, palabra: string): void {
    const element = event.currentTarget as HTMLElement;
  
    // Cambiar el fondo del contenedor
    element.style.background = "#FAE29E";
  
    // Mostrar los íconos
    const eyeIcons = element.querySelectorAll('.icon-eye');
  
    eyeIcons.forEach((icon) => {
      (icon as HTMLElement).style.visibility = "visible";
    });
  
  }
  
  quitarOjo(event: MouseEvent, categoria: string, palabra: string): void {
    const element = event.currentTarget as HTMLElement;
  
    // Restaurar el fondo del contenedor
    element.style.background = "transparent";
  
    // Ocultar los íconos
    const eyeIcons = element.querySelectorAll('.icon-eye');
  
    
  
  }

selectedWord: { [key: string]: string | null } = {};

selectWord(category: string, word: string): void {

  
  // Resetear todas las selecciones en otras categorías
  for (const cat in this.selectedWord) {
    if (cat !== category) {
      this.selectedWord[cat] = null;
    }
  }

  // Seleccionar la nueva palabra en la categoría actual
  this.selectedWord[category] = word;
}

async resetCategoryView(category: string) {
    this.selectedWord[category] = null;
  }

async updateCategory(category: string) {
  if (this.cambios_de_palabras.length === 0) {

    this.selectedWord[category] = null;
  }else{
    this.UpdateAWL = true;
    this.selectedWord[category] = null;

    await this.cambios_de_palabras.sort((a, b) => a.position - b.position);
    let data = {
      "palabras": this.cambios_de_palabras
    }

    await this.fachada.UpdateAWLWordCategory(this.http, sessionStorage.getItem('text_UID'), data)
    this.cambios_de_palabras = [];
    this.initAwl()
    setTimeout(() => {
      this.proyectoService.undoMarcadoMultiple(this.http);
      this.seeAllIconSrc = '../../assets/images/eye-icon.svg';
      Object.keys(this.isEyeOn).forEach(categoria => {
        this.isEyeOn[categoria] = false;
      });
      Object.keys(this.palabraresaltada).forEach(categoria => {
        Object.keys(this.palabraresaltada[categoria]).forEach(palabraResaltada => {
          this.palabraresaltada[categoria][palabraResaltada] = false;
        });
        Object.keys(this.palabraSeleccionada).forEach(key => {
          this.palabraSeleccionada[key] = false;
        });
      });
    }, 1000);
  }
}

updateSelectAllState(): void {
  const allSelected = Object.keys(this.ishighlighted)
      .filter(key => key !== 'awlTotal')  // Filtrar fuera 'awlTotal'
      .every(key => this.ishighlighted[key]); 

  const seeAllButtonIcon = document.querySelector('.see-all-icon') as HTMLImageElement; 
  if (seeAllButtonIcon) {
      seeAllButtonIcon.src = allSelected 
          ? './assets/images/yellow_icons/eye-on-icon.svg' 
          : './assets/images/eye-icon.svg';
  }
}

  
isEyeOn: { [key: string]: boolean } = {};
categoriasActivas: Set<string> = new Set();
palabraSeleccionada: { [key: string]: boolean } = {};

verPalabra(palabra: string, categoria: string, index: number, desdeOjo: boolean = true): void {
  const categoriaUpper = categoria.toUpperCase();
  const key = `${categoriaUpper}-${palabra}-${index}`;

  // Apagar todos los ojos activados por toggleEyeIcon
  Object.keys(this.isEyeOn).forEach(categoria => {
    this.isEyeOn[categoria] = false;
  });
  this.categoriasActivas.clear();

  this.seeAllIconSrc = '../../assets/images/eye-icon.svg';


  // Verificar si la categoría existe
  if (!this.data_pof3[categoriaUpper]) {
    console.error(`No se encontró la categoría "${categoriaUpper}".`);

    return;
  }

  // Verificar si la palabra existe dentro de la categoría
  const palabraData = this.data_pof3[categoriaUpper]?.[palabra];

  if (!palabraData || !Array.isArray(palabraData) || palabraData.length === 0) {
    console.error(`No se encontró la palabra "${palabra}" en la categoría "${categoriaUpper}" o no tiene posiciones válidas.`);
  
    return;
  }

 

  // Si el ojo está encendido y lo presionas, se apaga
  if (desdeOjo && this.palabraSeleccionada[key]) {
    this.palabraSeleccionada[key] = false;

    this.proyectoService.undoMarcadoMultiple(this.http);
    return;
  }

  // **Apagar todas las palabras resaltadas activadas por toggleEyeIconPalabra**
  Object.keys(this.palabraresaltada).forEach(categoria => {
    Object.keys(this.palabraresaltada[categoria]).forEach(palabraResaltada => {
      this.palabraresaltada[categoria][palabraResaltada] = false;
    });
  });

  // Primero apagamos todas las palabras antes de encender una nueva (excepto si es el mismo ojo)
  Object.keys(this.palabraSeleccionada).forEach(k => {
    this.palabraSeleccionada[k] = false;
  });

  // Encender la palabra seleccionada
  this.palabraSeleccionada[key] = true;

  // Recopilar posiciones de la palabra en la categoría seleccionada
  const posicionesSeleccionadas: { posicion: number; categoria: string }[] = palabraData.map(pos => ({
    posicion: pos,
    categoria: categoriaUpper
  }));

 

  // Verificar que el índice solicitado es válido
  if (index < 0 || index >= posicionesSeleccionadas.length) {
    console.error(`Índice fuera de rango: ${index}`);
    return;
  }

  // Obtener la posición específica de la palabra seleccionada en la categoría
  const posicionSeleccionada = posicionesSeleccionadas[index].posicion;



  // Recopilar posiciones de todas las categorías
  const posicionesOtrasCategorias: { posicion: number; categoria: string }[] = [];
  Object.keys(this.data_pof3).forEach(key => {
    if (key !== categoriaUpper) {
      const palabraEnCategoria = this.data_pof3[key]?.[palabra];
      if (palabraEnCategoria && Array.isArray(palabraEnCategoria) && palabraEnCategoria.length > 0) {
        palabraEnCategoria.forEach(pos => {
          posicionesOtrasCategorias.push({ posicion: pos, categoria: key });
        });
      }
    }
  });

 

  // Combinar todas las posiciones
  const todasLasPosiciones = [...posicionesSeleccionadas, ...posicionesOtrasCategorias];

  // Ordenar todas las posiciones de menor a mayor
  todasLasPosiciones.sort((a, b) => a.posicion - b.posicion);



  // Determinar el orden de la palabra seleccionada en el texto
  const ordenSeleccionado = todasLasPosiciones.findIndex(
    posObj => posObj.categoria === categoriaUpper && posObj.posicion === posicionSeleccionada
  );

  if (ordenSeleccionado !== -1) {

    this.proyectoService.resaltarCoincidenciaOrdenada(
      palabra,
      categoriaUpper,
      todasLasPosiciones,
      ordenSeleccionado + 1, // Empieza en 1
      this.http
    );
  } else {
    console.log(`No se encontró orden válido para la posición ${posicionSeleccionada} en la categoría "${categoriaUpper}".`);
  }
}

toggleEyeIcon(data: string): void {
  const categoriaUpper = data.toUpperCase();

  if (!this.data_pof3[categoriaUpper]) {
    console.error(`No se encontró la categoría "${categoriaUpper}".`);
    return;
  }
  // Apagar todos los ojos de verPalabra
  Object.keys(this.palabraSeleccionada).forEach(key => {
    this.palabraSeleccionada[key] = false;
  });

  const estadoActual = this.isEyeOn[categoriaUpper] || false;

  if (estadoActual) {
    this.categoriasActivas.delete(categoriaUpper);
    this.isEyeOn[categoriaUpper] = false;

    // Si "See All" estaba activo y desactivamos una categoría, apagamos solo el botón sin resetear todo
    if (this.seeAllActive) {
      this.seeAllActive = false;
    }

    // Si era la única categoría activa, llamar `undoMarcadoMultiple()`
    if (this.categoriasActivas.size === 0) {
      this.proyectoService.undoMarcadoMultiple(this.http);
    } else {
      this.actualizarResaltadoTexto();
    }
  } else {
    this.categoriasActivas.add(categoriaUpper);
    this.isEyeOn[categoriaUpper] = true;

    // **Apagar todos los ojos de las palabras**
    Object.keys(this.palabraresaltada).forEach(categoria => {
      Object.keys(this.palabraresaltada[categoria]).forEach(palabra => {
        this.palabraresaltada[categoria][palabra] = false;
      });
    });

    this.actualizarResaltadoTexto();
  }

  // Solo activar "See All" si todas las categorías están prendidas
  const allOn = Object.keys(this.data_pof3).every(categoria => this.isEyeOn[categoria]);
  this.seeAllActive = allOn;
  this.seeAllIconSrc = allOn
      ? '../../assets/images/yellow_icons/eye-on-icon.svg'
      : '../../assets/images/eye-icon.svg';
}


// Método para actualizar el resaltado en el texto considerando solo las categorías activas
actualizarResaltadoTexto(): void {
  let posicionesGlobales: { categoria: string; palabra: string; posicion: number }[] = [];

  // Recorrer todas las categorías disponibles para capturar todas las coincidencias
  Object.keys(this.data_pof3).forEach(categoria => {
      Object.keys(this.data_pof3[categoria]).forEach(palabra => {
          this.data_pof3[categoria][palabra].forEach(posicion => {
              posicionesGlobales.push({ categoria, palabra, posicion });
          });
      });
  });

  // Ordenar todas las posiciones de acuerdo con su aparición en el texto
  posicionesGlobales.sort((a, b) => a.posicion - b.posicion);

  // Mapear palabras con su posición y la categoría más relevante
  let posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] } = {};

  posicionesGlobales.forEach(({ categoria, palabra, posicion }) => {
      if (!posicionesPorPalabra[palabra]) {
          posicionesPorPalabra[palabra] = [];
      }
      posicionesPorPalabra[palabra].push({ posicion, categoria });
  });

  // Condición para manejar una categoría seleccionada vs. múltiples categorías activas
  if (this.categoriasActivas.size === 1) {
      // Caso de una sola categoría activa: aplicar lógica específica
      const categoriaUnica = [...this.categoriasActivas][0];

      this.proyectoService.resaltarMultiplesCoincidenciasCategoria(
          Object.keys(this.data_pof3[categoriaUnica]),
          categoriaUnica,
          posicionesPorPalabra,
          this.http
      );
  } else {
      // Caso de múltiples categorías activas: aplicar resaltado estándar
      let posicionesFiltradas: { [key: string]: { posicion: number; categoria: string }[] } = {};

      // Filtrar posiciones por categorías activas y ordenar por posición
      Object.keys(posicionesPorPalabra).forEach(palabra => {
          // Filtrar solo las posiciones de las categorías activas
          posicionesFiltradas[palabra] = posicionesPorPalabra[palabra]
              .filter(({ categoria }) => this.categoriasActivas.has(categoria))
              // Ordenar las posiciones por su valor 'posicion'
              .sort((a, b) => a.posicion - b.posicion);
      });

      this.proyectoService.aplicarResaltado(posicionesFiltradas,this.http);
  }
}



seeAllHighlighted: boolean = false; // Controla el estado del botón "See All"
seeAllIconSrc: string = '../../assets/images/eye-icon.svg'; // Controla el ícono del botón "See All"
  

toggleEyeIconPalabra(data: string, palabra: string): void {
  try {
    const categoriaUpper = data.toUpperCase();

    if (!this.data_pof3[categoriaUpper] || !this.data_pof3[categoriaUpper][palabra]) {
      console.error(`No se encontró la palabra "${palabra}" en la categoría "${categoriaUpper}".`);
      return;
    }

    // Inicialización defensiva
    if (!this.palabraresaltada[categoriaUpper]) {
      console.warn(`Inicializando palabraresaltada[${categoriaUpper}]`);
      this.palabraresaltada[categoriaUpper] = {};
    }

    if (!(palabra in this.palabraresaltada[categoriaUpper])) {
      console.warn(`Inicializando palabraresaltada[${categoriaUpper}][${palabra}]`);
      this.palabraresaltada[categoriaUpper][palabra] = false;
    }

    const estadoActual = this.palabraresaltada[categoriaUpper][palabra];

    if (estadoActual) {
      this.palabraresaltada[categoriaUpper][palabra] = false;
      this.proyectoService.undoMarcado([palabra], categoriaUpper);
      return;
    }

    // Apagar todas las palabras resaltadas en todas las categorías
    Object.keys(this.palabraresaltada).forEach(categoria => {
      Object.keys(this.palabraresaltada[categoria]).forEach(palabraResaltada => {
        this.palabraresaltada[categoria][palabraResaltada] = false;
      });
    });

    // Apagar ojos
    Object.keys(this.isEyeOn).forEach(categoria => {
      this.isEyeOn[categoria] = false;
    });

    this.categoriasActivas.clear();
    this.seeAllActive = false;
    this.seeAllIconSrc = '../../assets/images/eye-icon.svg';

    // Limpiar palabraSeleccionada
    Object.keys(this.palabraSeleccionada).forEach(key => {
      this.palabraSeleccionada[key] = false;
    });

    // Organizar posiciones globales
    let posicionesGlobales: { categoria: string; palabra: string; posicion: number }[] = [];

    Object.keys(this.data_pof3).forEach(categoria => {
      Object.keys(this.data_pof3[categoria]).forEach(palabra => {
        this.data_pof3[categoria][palabra].forEach(posicion => {
          posicionesGlobales.push({ categoria, palabra, posicion });
        });
      });
    });

    posicionesGlobales.sort((a, b) => a.posicion - b.posicion);

    let posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] } = {};

    posicionesGlobales.forEach(({ categoria, palabra, posicion }) => {
      if (!posicionesPorPalabra[palabra]) {
        posicionesPorPalabra[palabra] = [];
      }
      posicionesPorPalabra[palabra].push({ posicion, categoria });
    });

    this.palabraresaltada[categoriaUpper][palabra] = true;


    this.proyectoService.resaltarMultiplesCoincidencias([palabra], categoriaUpper, posicionesPorPalabra,this.http);

  } catch (error) {
    console.error('Error dentro de toggleEyeIconPalabra:', error);
  }
}



seeAllActive: boolean = false;
toggleSeeAll(): void {
  const allOn = !this.seeAllActive; // Invertir el estado actual

// Apagar todas las palabras resaltadas
Object.keys(this.palabraresaltada).forEach(categoria => {
  Object.keys(this.palabraresaltada[categoria]).forEach(palabra => {
      this.palabraresaltada[categoria][palabra] = false;
  });
});

// Apagar todos los ojos de verPalabra
Object.keys(this.palabraSeleccionada).forEach(key => {
  this.palabraSeleccionada[key] = false;
});


  
  // **Actualizar el estado de cada categoría correctamente**
  Object.keys(this.data_pof3).forEach(categoria => {
      this.isEyeOn[categoria] = allOn;
      if (allOn) {
          this.categoriasActivas.add(categoria);
      } else {
          this.categoriasActivas.delete(categoria);
      }

  });

  // Actualizar el estado del botón "See All"
  this.seeAllActive = allOn;
  this.seeAllIconSrc = allOn
      ? '../../assets/images/yellow_icons/eye-on-icon.svg'
      : '../../assets/images/eye-icon.svg';

  if (allOn) {
      // Resaltar todas las categorías
      let posicionesGlobales: { categoria: string; palabra: string; posicion: number }[] = [];

      Object.keys(this.data_pof3).forEach(categoria => {
          Object.keys(this.data_pof3[categoria]).forEach(palabra => {
              this.data_pof3[categoria][palabra].forEach(posicion => {
                  posicionesGlobales.push({ categoria, palabra, posicion });
              });
          });
      });

      posicionesGlobales.sort((a, b) => a.posicion - b.posicion);

      let posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] } = {};

      posicionesGlobales.forEach(({ categoria, palabra, posicion }) => {
          if (!posicionesPorPalabra[palabra]) {
              posicionesPorPalabra[palabra] = [];
          }
          posicionesPorPalabra[palabra].push({ posicion, categoria });
      });

      this.proyectoService.resaltarTodasLasCategorias(posicionesPorPalabra,this.http);
  } else {
      // Solo ejecutar `undoMarcadoMultiple()` cuando "See All" estaba activado y ahora se apaga
      this.proyectoService.undoMarcadoMultiple(this.http);
  }
}


  

  traducirColor(item){
    switch (item){
      case "awl1":
        return "#F70A17"
      case "awl2":
        return "#CCCC00"
      case "awl3":
        return "#6699FF"
      case "awl4":
        return "#FF99CC"
      case "awl5":
        return "#999966"
      case "awl6":
        return "#669999"
      case "awl7":
        return "#773399"
      case "awl8":
        return "#66cc33"
      case "awl9":
        return "#0080FF"
      case "awl10":
        return "#FF0080"
      case "k1":
        return "#8B1F8E"
      case "k2":
        return "#2849F9"
      case "k3":
        return "#156D31"
      case "k4":
        return "#F86A1D"
      case "k5":
        return "#1B908E"
      case "awlTotal":
        return "transparent"
      case "unlisted":
        return "transparent"
      default:
        return "#2A3654"
    }
  }

  isButtonDisabled(): boolean {
    return !sessionStorage.getItem("text_UID"); 
  }

  export_detallado() {
    let respaldo_ID = document.getElementById("PROJECT_ID_RESPALDO") as HTMLInputElement
    if (respaldo_ID) {
      if (respaldo_ID.value != '' && respaldo_ID.value != null) {
          this.fachada.detail_export("academicwordlist", respaldo_ID.value)
      } else {
        alert("No hay proyecto cargado")
      }
    } else {
      alert("No esta en la página principal")
    }
  }

  export_tagger() {
    let respaldo_ID = document.getElementById("PROJECT_ID_RESPALDO") as HTMLInputElement
    if (respaldo_ID) {
      if (respaldo_ID.value != '' && respaldo_ID.value != null) {
          this.fachada.tagger_export("academicwordlist", respaldo_ID.value)
      } else {
        alert("No hay proyecto cargado")
      }
    } else {
      alert("No esta en la página principal")
    }
  }
}

